module.exports = __webpack_public_path__ + "static/media/16_l_stena_86.15_0.0748fa56.png";